/*============================================================================
  Velpe Features — behavior for clean-room sections & blocks (Batch 1).
  Custom elements: countdown, sticky ATC, promo popup, urgency.
  © Velpe-Outdoor. No external dependencies.
==============================================================================*/
(function () {
  'use strict';

  /* ---------------- Countdown timer ---------------- */
  if (!customElements.get('velpe-countdown')) {
    customElements.define('velpe-countdown', class extends HTMLElement {
      connectedCallback() {
        this.end = this.resolveEnd();
        this.els = {
          d: this.querySelector('[data-d]'), h: this.querySelector('[data-h]'),
          m: this.querySelector('[data-m]'), s: this.querySelector('[data-s]')
        };
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      resolveEnd() {
        var fixed = this.getAttribute('data-end'); // ISO date
        if (fixed) { var t = Date.parse(fixed); if (!isNaN(t)) return t; }
        // Evergreen: per-visitor countdown of N minutes, persisted in localStorage.
        var mins = parseInt(this.getAttribute('data-minutes'), 10) || 60;
        var key = 'velpe_cd_' + (this.getAttribute('data-key') || this.id || 'default');
        var stored = parseInt(localStorage.getItem(key), 10);
        var now = Date.now();
        if (!stored || stored < now) { stored = now + mins * 60000; localStorage.setItem(key, stored); }
        return stored;
      }
      tick() {
        var diff = Math.max(0, this.end - Date.now());
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        var pad = function (n) { return String(n).padStart(2, '0'); };
        if (this.els.d) this.els.d.textContent = pad(d);
        if (this.els.h) this.els.h.textContent = pad(h);
        if (this.els.m) this.els.m.textContent = pad(m);
        if (this.els.s) this.els.s.textContent = pad(s);
        if (diff <= 0) { clearInterval(this.timer); if (this.getAttribute('data-hide-expired')) this.style.display = 'none'; }
      }
    });
  }

  /* ---------------- Sticky add-to-cart ---------------- */
  if (!customElements.get('velpe-sticky-atc')) {
    customElements.define('velpe-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        // position:fixed only anchors to the viewport when NO ancestor has a
        // transform/filter/perspective. The product-info column usually does
        // (scroll-reveal animations, sticky column), which would pin the bar
        // inside that column instead of the screen edge. So relocate the bar to
        // <body>. Dedupe by section across theme-editor re-renders.
        if (this.parentElement && this.parentElement !== document.body) {
          var key = this.getAttribute('data-section') || '';
          var esc = (window.CSS && CSS.escape) ? CSS.escape(key) : key;
          var me = this;
          document.querySelectorAll('body > velpe-sticky-atc[data-relocated="' + esc + '"]').forEach(function (n) { if (n !== me) n.remove(); });
          this.setAttribute('data-relocated', key);
          document.body.appendChild(this); // re-fires connectedCallback (parent === body)
          return;
        }
        if (this._wired) return;
        this._wired = true;
        var self = this;
        this.formSelector = this.getAttribute('data-form-target') || 'form[action$="/cart/add"]';
        this.watchSelector = this.getAttribute('data-watch') || '.product-form__buttons';
        this.button = this.querySelector('[data-sticky-add]');

        // Proxy the sticky button to the REAL product form. Resolve the form at
        // click time so it works no matter where this block sits in the order.
        if (this.button) {
          this.button.addEventListener('click', function () {
            var form = document.querySelector(self.formSelector) || document.querySelector('form[action$="/cart/add"]');
            var submit = form && form.querySelector('[type="submit"], button[name="add"]');
            if (submit) submit.click();
          });
        }

        // Show the bar once the main ATC scrolls out of view. The anchor may be
        // absent (rendered before buy-buttons) or replaced on variant change.
        this.setupObserver();
        if (!this._io) {
          if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { self.setupObserver(); });
          else requestAnimationFrame(function () { self.setupObserver(); });
        }
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
          this._unsub = subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
            requestAnimationFrame(function () { self.setupObserver(true); });
            self.syncVariant(e && e.data && e.data.variant);
          });
        }
      }
      // keep the sticky image / price / availability in sync with the variant
      syncVariant(v) {
        if (!v) return;
        var img = this.querySelector('[data-sticky-image]');
        if (img && v.featured_image && v.featured_image.src) {
          img.src = v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2');
        }
        var vname = this.querySelector('[data-sticky-variant]');
        if (vname && v.title) vname.textContent = v.title;
        var price = this.querySelector('[data-sticky-price]');
        if (price && typeof v.price === 'number') price.textContent = money(v.price);
        var cmp = this.querySelector('[data-sticky-compare]');
        if (cmp) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            cmp.textContent = money(v.compare_at_price); cmp.hidden = false;
          } else { cmp.hidden = true; }
        }
        var btn = this.querySelector('[data-sticky-add]');
        if (btn) btn.disabled = v.available === false;
      }
      setupObserver(force) {
        var anchor = document.querySelector(this.watchSelector);
        if (!anchor) return; // no main ATC on the page yet — retry later
        if (this._io && !force && this._anchor === anchor) return;
        if (this._io) this._io.disconnect();
        this._anchor = anchor;
        var self = this;
        if ('IntersectionObserver' in window) {
          this._io = new IntersectionObserver(function (entries) {
            self.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
          }, { threshold: 0 });
          this._io.observe(anchor);
        } else {
          this.classList.add('is-visible');
        }
      }
      disconnectedCallback() { if (this._unsub) this._unsub(); if (this._io) this._io.disconnect(); }
    });
  }

  /* ---------------- Promo popup ---------------- */
  if (!customElements.get('velpe-popup')) {
    customElements.define('velpe-popup', class extends HTMLElement {
      connectedCallback() {
        this.box = this.querySelector('.velpe-popup');
        if (!this.box) return;
        this.key = 'velpe_popup_' + (this.getAttribute('data-key') || 'default');
        this.days = parseInt(this.getAttribute('data-frequency'), 10) || 7;
        if (window.Shopify && window.Shopify.designMode) { return this.open(); } // always show in editor
        if (this.seen()) return;
        var delay = (parseInt(this.getAttribute('data-delay'), 10) || 3) * 1000;
        this.t = setTimeout(() => this.open(), delay);
        this.box.querySelectorAll('[data-popup-close]').forEach((b) =>
          b.addEventListener('click', () => this.close()));
        this.box.querySelector('.velpe-popup__overlay')?.addEventListener('click', () => this.close());
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
      }
      seen() {
        var ts = parseInt(localStorage.getItem(this.key), 10);
        return ts && (Date.now() - ts) < this.days * 86400000;
      }
      open() {
        if (this.box.classList.contains('is-open')) return;
        this._lastFocus = document.activeElement;
        this.box.classList.add('is-open');
        // focus into the dialog + trap Tab (matches Dawn modal behavior)
        var focusTarget = this.box.querySelector(
          '.velpe-popup__close, button:not([disabled]), [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
        ) || this.box;
        if (typeof trapFocus === 'function') {
          trapFocus(this.box, focusTarget);
        } else if (focusTarget.focus) {
          focusTarget.focus();
        }
      }
      close() {
        if (!this.box.classList.contains('is-open')) return;
        this.box.classList.remove('is-open');
        localStorage.setItem(this.key, Date.now());
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(this._lastFocus);
        } else if (this._lastFocus && this._lastFocus.focus) {
          this._lastFocus.focus();
        }
      }
    });
  }

  /* ---------------- Urgency: live viewers ---------------- */
  if (!customElements.get('velpe-urgency')) {
    customElements.define('velpe-urgency', class extends HTMLElement {
      connectedCallback() {
        var node = this.querySelector('[data-viewers]');
        if (!node) return;
        var min = parseInt(this.getAttribute('data-min'), 10) || 8;
        var max = parseInt(this.getAttribute('data-max'), 10) || 40;
        var tmpl = node.getAttribute('data-template') || '[n] people are viewing this';
        // Deterministic-ish per page load, then drift slightly so it feels live.
        var current = min + Math.floor(Math.random() * (max - min + 1));
        var render = () => { node.textContent = tmpl.replace('[n]', current); };
        render();
        setInterval(() => {
          current += Math.random() < 0.5 ? -1 : 1;
          current = Math.max(min, Math.min(max, current));
          render();
        }, 4000 + Math.floor(Math.random() * 3000));
      }
    });
  }

  /* ---------------- helpers ---------------- */
  function money(cents) {
    var amount = cents / 100;
    try {
      var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(amount);
    } catch (e) { return amount.toFixed(2); }
  }
  function cartAdd(items) {
    return fetch((window.Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    });
  }
  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      fetch((window.Shopify.routes.root || '/') + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          try {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('cart-drawer');
            if (fresh) drawer.innerHTML = fresh.innerHTML;
          } catch (e) {}
          drawer.classList.remove('is-empty');
          drawer.open();
        });
    } else {
      window.location = (window.Shopify.routes.root || '/') + 'cart';
    }
  }

  /* ---------------- Bundle: frequently bought together ---------------- */
  if (!customElements.get('velpe-bundle')) {
    customElements.define('velpe-bundle', class extends HTMLElement {
      connectedCallback() {
        this.boxes = Array.from(this.querySelectorAll('input[type="checkbox"][data-variant]'));
        this.totalEl = this.querySelector('[data-bundle-total]');
        this.wasEl = this.querySelector('[data-bundle-was]');
        this.addBtn = this.querySelector('[data-bundle-add]');
        this.boxes.forEach((b) => b.addEventListener('change', () => this.refresh()));
        if (this.addBtn) this.addBtn.addEventListener('click', () => this.add());
        this.refresh();
      }
      refresh() {
        var gross = this.boxes.reduce((sum, b) =>
          b.checked ? sum + parseInt(b.dataset.price, 10) : sum, 0);
        var pct = parseFloat(this.getAttribute('data-discount-percent')) || 0;
        var fixed = parseInt(this.getAttribute('data-discount-fixed'), 10) || 0;
        var net = gross;
        if (pct > 0) net = Math.round(gross * (100 - pct) / 100);
        if (fixed > 0) net = Math.max(0, net - fixed);
        if (this.totalEl) this.totalEl.innerHTML = money(net);
        if (this.wasEl) this.wasEl.innerHTML = (net < gross && gross > 0) ? money(gross) : '';
        if (this.addBtn) this.addBtn.disabled = gross === 0;
      }
      add() {
        var items = this.boxes.filter((b) => b.checked)
          .map((b) => ({ id: parseInt(b.dataset.variant, 10), quantity: 1 }));
        if (!items.length) return;
        this.addBtn.disabled = true;
        cartAdd(items).then(() => openCartDrawer())
          .finally(() => { this.addBtn.disabled = false; });
      }
    });
  }

  /* ---------------- Generic modal (size chart etc.) ---------------- */
  if (!customElements.get('velpe-modal')) {
    customElements.define('velpe-modal', class extends HTMLElement {
      connectedCallback() {
        this.modal = this.querySelector('.velpe-modal');
        this.querySelectorAll('[data-modal-open]').forEach((b) =>
          b.addEventListener('click', () => this.modal.classList.add('is-open')));
        this.querySelectorAll('[data-modal-close], .velpe-modal__overlay').forEach((b) =>
          b.addEventListener('click', () => this.modal.classList.remove('is-open')));
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.modal) this.modal.classList.remove('is-open');
        });
      }
    });
  }

  /* ---------------- Estimated shipping ---------------- */
  if (!customElements.get('velpe-eta')) {
    customElements.define('velpe-eta', class extends HTMLElement {
      connectedCallback() {
        var node = this.querySelector('[data-eta-date]');
        if (!node) return;
        var processing = parseInt(this.getAttribute('data-processing'), 10) || 1;
        var min = parseInt(this.getAttribute('data-min'), 10) || 3;
        var max = parseInt(this.getAttribute('data-max'), 10) || 7;
        var skipWeekend = this.getAttribute('data-skip-weekend') === 'true';

        var addBusiness = function (date, days) {
          var d = new Date(date);
          var added = 0;
          while (added < days) {
            d.setDate(d.getDate() + 1);
            if (!skipWeekend || (d.getDay() !== 0 && d.getDay() !== 6)) added++;
          }
          return d;
        };
        var base = new Date();
        var from = addBusiness(base, processing + min);
        var to = addBusiness(base, processing + max);
        var fmt = function (d) { return d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' }); };
        node.textContent = fmt(from) + ' – ' + fmt(to);
      }
    });
  }

  /* ---------------- Complementary: quick add ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-comp-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    cartAdd([{ id: parseInt(btn.dataset.compAdd, 10), quantity: 1 }])
      .then(() => openCartDrawer())
      .finally(() => { btn.disabled = false; });
  });

  /* ---------------- Product tabs ---------------- */
  if (!customElements.get('velpe-tabs')) {
    customElements.define('velpe-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab)));
      }
      select(tab) {
        this.tabs.forEach((t) => {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
    });
  }

  /* ---------------- Before / after slider ---------------- */
  if (!customElements.get('velpe-before-after')) {
    customElements.define('velpe-before-after', class extends HTMLElement {
      connectedCallback() {
        this.after = this.querySelector('.velpe-ba__after');
        this.handle = this.querySelector('.velpe-ba__handle');
        this.dragging = false;
        var move = (clientX) => {
          var rect = this.getBoundingClientRect();
          var pct = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
          this.after.style.width = pct + '%';
          this.handle.style.left = pct + '%';
        };
        var start = () => { this.dragging = true; };
        var end = () => { this.dragging = false; };
        this.addEventListener('pointerdown', (e) => { start(); move(e.clientX); });
        window.addEventListener('pointermove', (e) => { if (this.dragging) move(e.clientX); });
        window.addEventListener('pointerup', end);
      }
    });
  }

  /* ---------------- Shoppable image hotspots (mobile tap) ---------------- */
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.velpe-shop__dot');
    var spot = dot && dot.closest('.velpe-shop__spot');
    document.querySelectorAll('.velpe-shop__spot.is-open').forEach(function (s) {
      if (s !== spot) s.classList.remove('is-open');
    });
    if (spot) { e.stopPropagation(); spot.classList.toggle('is-open'); }
  });

  /* ---------------- Parallax hero ---------------- */
  if (!customElements.get('velpe-parallax')) {
    customElements.define('velpe-parallax', class extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.bg = this.querySelector('.velpe-parallax__bg');
        if (!this.bg) return;
        var speed = parseFloat(this.getAttribute('data-speed')) || 0.3;
        var ticking = false;
        var update = () => {
          var rect = this.getBoundingClientRect();
          if (rect.bottom > 0 && rect.top < window.innerHeight) {
            var offset = (window.innerHeight - rect.top) * speed;
            this.bg.style.transform = 'translateY(' + (offset * -0.1) + 'px)';
          }
          ticking = false;
        };
        window.addEventListener('scroll', () => {
          if (!ticking) { requestAnimationFrame(update); ticking = true; }
        }, { passive: true });
        update();
      }
    });
  }

  /* ---------------- Slideshow hero ---------------- */
  if (!customElements.get('velpe-hero')) {
    customElements.define('velpe-hero', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.velpe-hero__track');
        this.slides = Array.from(this.querySelectorAll('.velpe-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('.velpe-hero__dot'));
        this.index = 0;
        this.go(0); // mark the first slide/dot active on load (fade + Ken Burns)
        if (this.slides.length < 2) return;
        this.querySelector('.velpe-hero__arrow--prev')?.addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('.velpe-hero__arrow--next')?.addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.auto = parseInt(this.getAttribute('data-autoplay'), 10) || 0;
        if (this.auto > 0 && !reduce) {
          this.start();
          this.addEventListener('mouseenter', () => { if (!this._userPaused) this.stop(); });
          this.addEventListener('mouseleave', () => { if (!this._userPaused) this.start(); });
          // keyboard users: pause while focus is inside, resume when it leaves
          this.addEventListener('focusin', () => { if (!this._userPaused) this.stop(); });
          this.addEventListener('focusout', () => { if (!this._userPaused && !this.contains(document.activeElement)) this.start(); });
          this.addPauseButton(); // WCAG 2.2.2: an explicit, keyboard-accessible pause control
        }
      }
      disconnectedCallback() { this.stop(); }
      addPauseButton() {
        var self = this;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'velpe-hero__pause';
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-label', 'Diashow pausieren');
        btn.innerHTML = '<span class="velpe-hero__pause-icon" aria-hidden="true">&#10073;&#10073;</span>';
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          self._userPaused = !self._userPaused;
          if (self._userPaused) {
            self.stop();
            btn.setAttribute('aria-pressed', 'true');
            btn.setAttribute('aria-label', 'Diashow abspielen');
            btn.querySelector('.velpe-hero__pause-icon').innerHTML = '&#9658;';
          } else {
            self.start();
            btn.setAttribute('aria-pressed', 'false');
            btn.setAttribute('aria-label', 'Diashow pausieren');
            btn.querySelector('.velpe-hero__pause-icon').innerHTML = '&#10073;&#10073;';
          }
        });
        (this.querySelector('.velpe-hero__dots') || this).appendChild(btn);
      }
      start() { this.stop(); if (this.auto > 0 && !this._userPaused) this.timer = setInterval(() => this.go(this.index + 1), this.auto * 1000); }
      stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
      go(i) {
        var n = this.slides.length;
        if (!n) return;
        this.index = (i + n) % n;
        if (this.track) this.track.style.transform = 'translateX(-' + (this.index * 100) + '%)';
        // toggle active state on slides too, so fade/Ken-Burns work without a
        // separate observer mirroring the dots
        this.slides.forEach((s, si) => s.classList.toggle('is-active', si === this.index));
        this.dots.forEach((d, di) => d.classList.toggle('is-active', di === this.index));
      }
    });
  }

  /* ---------------- Image slider arrows ---------------- */
  if (!customElements.get('velpe-image-slider')) {
    customElements.define('velpe-image-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.velpe-islider__track');
        if (!this.track) return;
        var step = () => this.track.querySelector('.velpe-islider__slide')?.offsetWidth + 16 || 320;
        this.querySelector('.velpe-islider__btn--prev')?.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
        this.querySelector('.velpe-islider__btn--next')?.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
      }
    });
  }

  /* ---------------- Stories viewer (TikTok / Insta) ---------------- */
  if (!customElements.get('velpe-stories')) {
    customElements.define('velpe-stories', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.velpe-stories__item'));
        this.sources = this.items.map((it) => it.dataset.video).filter(Boolean);
        this.viewer = this.querySelector('.velpe-stories__viewer');
        this.video = this.querySelector('video');
        this.index = 0;
        if (!this.viewer || !this.video) return;
        this.items.forEach((it, i) => it.addEventListener('click', () => this.open(i)));
        this.querySelector('.velpe-stories__close')?.addEventListener('click', () => this.close());
        this.querySelector('.velpe-stories__nav--prev')?.addEventListener('click', () => this.play(this.index - 1));
        this.querySelector('.velpe-stories__nav--next')?.addEventListener('click', () => this.play(this.index + 1));
        this.video.addEventListener('ended', () => this.play(this.index + 1));
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
      }
      open(i) { this.viewer.classList.add('is-open'); this.play(i); }
      close() { this.viewer.classList.remove('is-open'); this.video.pause(); }
      play(i) {
        if (i < 0) i = 0;
        if (i >= this.sources.length) return this.close();
        this.index = i;
        this.video.src = this.sources[i];
        this.video.play().catch(function () {});
      }
    });
  }

  /* ---------------- Track order redirect ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-track-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[name="tracking"]');
    var base = form.getAttribute('data-track-url') || 'https://t.17track.net/en#nums=';
    if (input && input.value.trim()) {
      window.open(base + encodeURIComponent(input.value.trim()), '_blank', 'noopener');
    }
  });

  /* ---------------- Music player (floating audio toggle) ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-velpe-music]');
    if (!btn) return;
    var wrap = btn.closest('.velpe-music');
    var audio = wrap && wrap.querySelector('audio');
    if (!audio) return;
    var setState = function (playing) {
      btn.classList.toggle('is-playing', playing);
      btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      var label = playing
        ? (btn.getAttribute('data-label-pause') || 'Pause music')
        : (btn.getAttribute('data-label-play') || 'Play music');
      btn.setAttribute('aria-label', label);
    };
    if (audio.paused) {
      var vol = parseFloat(wrap.getAttribute('data-volume'));
      if (!isNaN(vol)) audio.volume = Math.max(0, Math.min(1, vol));
      audio.play().then(function () { setState(true); }).catch(function () {});
    } else {
      audio.pause();
      setState(false);
    }
  });

  /* ---------------- Page scroll progress bar ---------------- */
  if (!customElements.get('velpe-scroll-progress')) {
    customElements.define('velpe-scroll-progress', class extends HTMLElement {
      connectedCallback() {
        this.fill = this.querySelector('.velpe-progress__fill');
        if (!this.fill) return;
        var self = this;
        var ticking = false;
        var update = function () {
          ticking = false;
          var h = document.documentElement;
          var max = (h.scrollHeight - h.clientHeight) || 1;
          var pct = Math.max(0, Math.min(100, (h.scrollTop || window.pageYOffset) / max * 100));
          self.fill.style.width = pct + '%';
          if (self.getAttribute('data-show-percentage') === 'true') {
            self.fill.setAttribute('data-label', Math.round(pct) + '%');
          }
        };
        // rAF-throttle: never read+write layout more than once per frame (PF-7)
        this._onScroll = function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll);
        update();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
      }
    });
  }

  /* ====================================================================
     Reusable carousel  <velpe-slider>  — replaces Shrine's splide.
     Markup:
       <velpe-slider data-per-view="3" data-per-view-tablet="2"
                       data-per-view-mobile="1" data-gap="16"
                       data-autoplay="0" data-arrows="true" data-dots="true"
                       data-pause-hover="true" data-loop="false">
         <button class="velpe-slider__arrow velpe-slider__arrow--prev" …>
         <div class="velpe-slider__viewport">
           <div class="velpe-slider__track">
             <div class="velpe-slider__slide">…</div> …
           </div>
         </div>
         <button class="velpe-slider__arrow velpe-slider__arrow--next" …>
         <div class="velpe-slider__dots"></div>
       </velpe-slider>
     Per-view/gap drive CSS vars; drag, wheel-snap, arrows (by page), dots,
     autoplay (pause on hover/focus/offscreen), RTL all handled here.
     ==================================================================== */
  if (!customElements.get('velpe-slider')) {
    customElements.define('velpe-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.velpe-slider__track');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.dotsWrap = this.querySelector('.velpe-slider__dots');
        this.prevBtn = this.querySelector('.velpe-slider__arrow--prev');
        this.nextBtn = this.querySelector('.velpe-slider__arrow--next');
        this.rtl = document.documentElement.dir === 'rtl' || document.dir === 'rtl';
        this.gap = parseInt(this.getAttribute('data-gap'), 10);
        if (isNaN(this.gap)) this.gap = 16;

        this.applyLayout();
        this.buildDots();
        this.bindArrows();
        this.bindDrag();
        this.bindScroll();
        this.bindAutoplay();

        this._onResize = this.debounce(() => { this.applyLayout(); this.buildDots(); this.update(); }, 150);
        window.addEventListener('resize', this._onResize);
        this.update();
      }
      disconnectedCallback() {
        window.removeEventListener('resize', this._onResize);
        clearInterval(this._auto);
      }
      perView() {
        var w = window.innerWidth;
        var d = parseFloat(this.getAttribute('data-per-view')) || 1;
        var t = parseFloat(this.getAttribute('data-per-view-tablet')) || Math.max(1, Math.round(d * 0.66)) || d;
        var m = parseFloat(this.getAttribute('data-per-view-mobile')) || 1;
        if (w <= 749) return m;
        if (w <= 989) return t;
        return d;
      }
      applyLayout() {
        var pv = this.perView();
        this.track.style.setProperty('--rs-pv', pv);
        this.track.style.setProperty('--rs-gap', this.gap + 'px');
      }
      pageSize() { return this.track.clientWidth + this.gap; }
      pageCount() {
        var pv = this.perView();
        return Math.max(1, Math.ceil(this.slides.length / Math.floor(pv) || 1));
      }
      buildDots() {
        if (!this.dotsWrap || this.getAttribute('data-dots') === 'false') { if (this.dotsWrap) this.dotsWrap.hidden = true; return; }
        var pages = this.pageCount();
        if (pages < 2) { this.dotsWrap.innerHTML = ''; this.dotsWrap.hidden = true; return; }
        this.dotsWrap.hidden = false;
        this.dotsWrap.innerHTML = '';
        for (var i = 0; i < pages; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'velpe-slider__dot';
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.dataset.page = i;
          b.addEventListener('click', this.goToPage.bind(this, i));
          this.dotsWrap.appendChild(b);
        }
        this.dots = Array.from(this.dotsWrap.children);
      }
      goToPage(i) {
        var dir = this.rtl ? -1 : 1;
        this.track.scrollTo({ left: dir * i * this.pageSize(), behavior: 'smooth' });
      }
      currentPage() {
        var p = Math.abs(this.track.scrollLeft) / this.pageSize();
        return Math.round(p);
      }
      bindArrows() {
        var dir = this.rtl ? -1 : 1;
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.track.scrollBy({ left: -dir * this.pageSize(), behavior: 'smooth' }));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => {
          // wrap to start when at (or near) the end
          var maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
          if (Math.abs(this.track.scrollLeft) >= maxScroll) { this.track.scrollTo({ left: 0, behavior: 'smooth' }); }
          else this.track.scrollBy({ left: dir * this.pageSize(), behavior: 'smooth' });
        });
      }
      bindDrag() {
        var down = false, startX = 0, startScroll = 0, moved = false;
        this.track.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'touch') return; // native touch scroll
          down = true; moved = false; startX = e.clientX; startScroll = this.track.scrollLeft;
          this.track.classList.add('is-dragging');
        });
        window.addEventListener('pointermove', (e) => {
          if (!down) return;
          var dx = e.clientX - startX;
          if (Math.abs(dx) > 4) moved = true;
          this.track.scrollLeft = startScroll - dx;
        });
        window.addEventListener('pointerup', () => {
          if (!down) return;
          down = false; this.track.classList.remove('is-dragging');
        });
        // prevent click after drag
        this.track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
      }
      bindScroll() {
        var raf;
        this.track.addEventListener('scroll', () => {
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => this.update());
        }, { passive: true });
      }
      update() {
        if (!this.dots || !this.dots.length) return;
        var cur = this.currentPage();
        this.dots.forEach((d, i) => d.classList.toggle('is-active', i === cur));
      }
      bindAutoplay() {
        var secs = parseFloat(this.getAttribute('data-autoplay')) || 0;
        if (secs <= 0) return;
        var advance = () => { if (this.nextBtn) this.nextBtn.click(); };
        var start = () => { clearInterval(this._auto); this._auto = setInterval(advance, secs * 1000); };
        var stop = () => clearInterval(this._auto);
        start();
        if (this.getAttribute('data-pause-hover') !== 'false') {
          this.addEventListener('mouseenter', stop);
          this.addEventListener('mouseleave', start);
          this.addEventListener('focusin', stop);
          this.addEventListener('focusout', start);
        }
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((es) => { es[0].isIntersecting ? start() : stop(); }, { threshold: 0 }).observe(this);
        }
      }
      debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }
    });
  }

  /* ====================================================================
     <velpe-video> — lightweight facade (replaces Shrine's internal-video).
     HTML5:  <velpe-video><video …><source …></video></velpe-video>
     YouTube/Vimeo (click-to-load, no autoplay tracking until clicked):
       <velpe-video data-type="youtube" data-id="VIDEOID" data-autoplay="false">
         <button class="velpe-video__poster" style="background-image:url(…)">
           <span class="velpe-video__play">▶</span>
         </button>
       </velpe-video>
     ==================================================================== */
  if (!customElements.get('velpe-video')) {
    customElements.define('velpe-video', class extends HTMLElement {
      connectedCallback() {
        this.type = this.getAttribute('data-type') || 'html5';
        this.poster = this.querySelector('.velpe-video__poster');
        if (this.type === 'html5') {
          if (this.getAttribute('data-autoplay') === 'true') {
            var v = this.querySelector('video');
            if (v && 'IntersectionObserver' in window) {
              new IntersectionObserver((es) => { es[0].isIntersecting ? v.play().catch(function () {}) : v.pause(); }, { threshold: 0.25 }).observe(this);
            }
          }
          return;
        }
        if (this.poster) this.poster.addEventListener('click', () => this.load());
      }
      load() {
        var id = this.getAttribute('data-id');
        if (!id) return;
        var src = this.type === 'vimeo'
          ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&title=0&byline=0'
          : 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.className = 'velpe-video__iframe';
        iframe.loading = 'lazy';
        this.innerHTML = '';
        this.appendChild(iframe);
      }
    });
  }

  /* ---------------- AX-2: inert background behind the cart & menu drawers ----------------
     Screen-reader containment (trapFocus already handles keyboard). Scoped to the
     two drawers, which both live OUTSIDE #MainContent, so we never inert an
     in-content modal (size chart / share / media) and break it. */
  (function () {
    if (!('inert' in HTMLElement.prototype)) return; // skip if unsupported
    var q = function (s) { return document.querySelector(s); };
    var main = function () { return document.getElementById('MainContent'); };
    var footer = function () { return q('.footer') || q('footer'); };
    var header = function () { return q('.header-wrapper') || q('header.header') || q('.section-header'); };
    function mark(el, on) {
      if (!el) return;
      if (on) { if (!el.hasAttribute('data-ovl-inert')) { el.setAttribute('inert', ''); el.setAttribute('data-ovl-inert', ''); } }
      else if (el.hasAttribute('data-ovl-inert')) { el.removeAttribute('inert'); el.removeAttribute('data-ovl-inert'); }
    }
    var cart = q('cart-drawer');
    if (cart) {
      new MutationObserver(function () {
        var open = cart.classList.contains('active');
        [main(), footer(), header()].forEach(function (el) { mark(el, open); });
      }).observe(cart, { attributes: true, attributeFilter: ['class'] });
    }
    var menu = document.getElementById('Details-menu-drawer-container');
    if (menu) {
      new MutationObserver(function () {
        var open = menu.classList.contains('menu-opening');
        // header holds the menu drawer, so only inert main + footer here
        [main(), footer()].forEach(function (el) { mark(el, open); });
      }).observe(menu, { attributes: true, attributeFilter: ['class', 'open'] });
    }
  })();

  /* ---------------- Marquee clone-to-fill (logo list + ticker) ----------------
     A 2-copy translateX(-50%) marquee only loops without a gap when ONE copy is at
     least as wide as the strip. With few/narrow items that isn't true on wide
     screens, so we clone the rendered set until each copy overflows the strip
     (mirrors Splide's clone-to-fill), then scale the duration to keep the speed. */
  (function () {
    // Force every image in the track to load (off-screen clones are lazy and would
    // otherwise stay 0-wide, making the two copies asymmetric), then call cb once all
    // are loaded so the -50% loop seam is exact.
    function loadAll(track, cb) {
      var imgs = track.querySelectorAll('img');
      var pending = 0;
      imgs.forEach(function (img) {
        img.loading = 'eager';
        if (img.complete && img.naturalWidth) return;
        pending++;
        var done = function () { if (--pending <= 0) cb(); };
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      });
      if (pending === 0) cb();
    }
    function fillMarquee(track) {
      if (!track._marqueeSet) track._marqueeSet = track.innerHTML;
      var strip = track.parentElement;
      track.classList.remove('is-marquee-ready'); // hold the animation until rebuilt + loaded
      track.innerHTML = track._marqueeSet; // one set, then measure it once its images are in
      loadAll(track, function () {
        var setWidth = track.scrollWidth;
        if (!setWidth) { track.classList.add('is-marquee-ready'); return; }
        var stripWidth = (strip && strip.clientWidth) || setWidth;
        // +1 so one copy strictly exceeds the strip (no hairline gap from rounding)
        var perCopy = Math.max(1, Math.ceil(stripWidth / setWidth) + 1);
        var copy = '';
        for (var i = 0; i < perCopy; i++) copy += track._marqueeSet;
        track.innerHTML = copy + copy; // two identical copies → -50% lands on a seam
        var speed = parseFloat(track.getAttribute('data-marquee-speed')) || 30;
        track.style.animationDuration = (speed * perCopy) + 's';
        // wait for the CLONED images too, so both copies have equal width, then start
        loadAll(track, function () { track.classList.add('is-marquee-ready'); });
      });
    }
    function initMarquees() {
      document.querySelectorAll('[data-marquee]').forEach(fillMarquee);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMarquees);
    } else {
      initMarquees();
    }
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initMarquees, 200);
    });
  })();
})();
